import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { CartProvider } from './contexts/CartContext';
import Header from './components/Header';
import Home from './components/Home';
import OurStory from './components/OurStory';
import Collection from './components/Collection';
import Shop from './components/Shop';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import OrderStatus from './components/OrderStatus';
import FlavourDeepDive from './components/FlavourDeepDive';
import StayInTheKnow from './components/StayInTheKnow';
import Contact from './components/Contact';
import About from './components/About';
import AgeVerification from './components/AgeVerification';
import Stories from './components/Stories';
import Waitlist from './components/Waitlist';
import Footer from './components/Footer';
import SEO from './components/SEO';

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <Router>
          <div className="App">
            <AgeVerification />
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/" element={
                  <>
                    <SEO
                      title="Premium Craft Spirits"
                      description="Crafted with intent. Experience spirits redefined. Discover our collection of premium craft spirits including gin, rum, and vodka."
                      url="/"
                    />
                    <Home />
                    <OurStory />
                    <Collection />
                    <FlavourDeepDive />
                    <StayInTheKnow />
                  </>
                } />
                <Route path="/shop" element={
                  <>
                    <SEO
                      title="Shop Our Collection"
                      description="Browse and purchase our premium craft spirits. Fire Engin Gin, Smokey Timber Rum, and Bonfire Toffee Vodka available now."
                      url="/shop"
                    />
                    <Shop />
                  </>
                } />
                <Route path="/cart" element={
                  <>
                    <SEO
                      title="Shopping Cart"
                      description="Review your cart and proceed to checkout for our premium craft spirits."
                      url="/cart"
                    />
                    <Cart />
                  </>
                } />
                <Route path="/checkout" element={
                  <>
                    <SEO
                      title="Checkout"
                      description="Complete your purchase of premium craft spirits from Fire House Spirits."
                      url="/checkout"
                    />
                    <Checkout />
                  </>
                } />
                <Route path="/order-status" element={
                  <>
                    <SEO
                      title="Order Status"
                      description="Track your Fire House Spirits order status and delivery updates."
                      url="/order-status"
                    />
                    <OrderStatus />
                  </>
                } />
                <Route path="/contact" element={
                  <>
                    <SEO
                      title="Contact Us"
                      description="Get in touch with Fire House Spirits for any questions, enquiries, or just to say hello."
                      url="/contact"
                    />
                    <Contact />
                  </>
                } />
                <Route path="/about" element={
                  <>
                    <SEO
                      title="About Us"
                      description="Learn more about Fire House Spirits, our story, and our commitment to quality."
                      url="/about"
                    />
                    <About />
                  </>
                } />
                <Route path="/stories" element={
                  <>
                    <SEO
                      title="Our Stories"
                      description="Discover the stories behind Fire House Spirits, our community, and our brand."
                      url="/stories"
                    />
                    <Stories />
                  </>
                } />
                <Route path="/wait" element={
                  <>
                    <SEO
                      title="Join the Monthly Serve Waitlist"
                      description="Join the waitlist for The Monthly Serve subscription box. Be the first to know when our curated spirits subscription launches."
                      url="/wait"
                    />
                    <Waitlist />
                  </>
                } />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
